import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useNewPatients } from 'app/components/analytics-new-patients/useNewPatients'
import { NewPatientsShadcnComponent } from 'app/components/analytics-new-patients/NewPatientsShadcnComponent'
import { defaultBecameLeadDateFilter } from 'app/components/analytics-new-patients/useNewPatients'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'

// Re-export for backwards compatibility
export { defaultBecameLeadDateFilter }

// observer: reads the staff-v2 feature toggle in render; useFeatureToggle resolves
// false -> real asynchronously and its contract requires an observer wrapper (TRK-6020).
const NewPatients = observer(function NewPatients() {
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()

  // Permission guard (PMS integration check now handled by the hook/component)
  if (staffV2Enabled && !checkPermission([`org:pages:analytics:new-patients`, `pages:analytics`])) {
    return <Navigate to="/analytics/marketing" replace />
  }

  const hookData = useNewPatients()
  return <NewPatientsShadcnComponent {...hookData} />
})

export default NewPatients
